"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const styledComponents_1 = require("../styledComponents");
const CopyToClipboard = ({ text }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const handleClick = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styledComponents_1.ThemedIconButton, { sx: { cursor: 'pointer', margin: '0 2px' }, "aria-label": "Copy to clipboard", onClick: () => {
                navigator.clipboard.writeText(text);
                handleClick();
            } },
            react_1.default.createElement(styledComponents_1.ThemedContentCopyIcon, { sx: { color: 'red' } })),
        react_1.default.createElement(styledComponents_1.CustomSnackBar, { open: open, autoHideDuration: 6000, onClose: handleClose },
            react_1.default.createElement(material_1.Alert, { onClose: handleClose, severity: "success", sx: { width: '100%' } }, "Address copied to the clipboard"))));
};
exports.default = CopyToClipboard;
